module.exports = __webpack_public_path__ + "img/零食1.bb51b432.png";